import { AppShell, PatientAppBar } from '@psyomics/ui-components';
import { Outlet } from 'react-router-dom';

import { HeaderIllustration } from '../../../shared/components/header-illustration-layout/header-illustration-layout';
import { usePatientAppBarContext } from '../../contexts/patient-app-bar';

const InsecureLayout = () => {
  const { showUrgentHelp, setShowUrgentHelp, withIllustration } = usePatientAppBarContext();

  return (
    <AppShell
      header={
        <PatientAppBar
          hideIcon
          onShowUrgentHelpDialogChange={setShowUrgentHelp}
          showUrgentHelpDialog={showUrgentHelp}
        />
      }
    >
      {withIllustration && <HeaderIllustration />}
      <Outlet />
    </AppShell>
  );
};

export { InsecureLayout };
